module.exports = __webpack_public_path__ + "img/DESIGN_10_video_prew.34cfd23e.jpg";